// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"GI2z_","centeredLogo":"_1UfOc","loginWrapper":"N3McH","pageTitle":"_1mFOv","centered":"_34XMD","centeredOptions":"_3Orig","link":"_391u8","logo":"_3g1zi"};